import { render, staticRenderFns } from "./SubmissionFormContactInfoItem.vue?vue&type=template&id=2d715884&scoped=true&"
import script from "./SubmissionFormContactInfoItem.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormContactInfoItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d715884",
  null
  
)

export default component.exports